import { jsxs as a, jsx as r } from "react/jsx-runtime";
import { ThermometerWrapper as l, SnowflakeIcon as i, ThermometerContainer as d, ThermometerColdArea as c, ThermometerNormalArea as h, ThermometerHotArea as s, DotWrapper as u, Dot as f, FireIcon as T } from "./styles.js";
import { Snowflake as p, FireFlameCurved as x } from "@pelando/fontawesome/icons";
const v = (e) => {
  const t = Math.round(e), o = {
    0: 8,
    1: 8,
    25: -12,
    75: -12,
    26: 8,
    76: 8,
    100: -16
  }[t];
  return `calc(${t}% + ${o || 0}px)`;
};
function D({
  priceRangeFit: e,
  noHistory: t,
  children: o,
  ...m
}) {
  const n = !t && e <= 100 && e >= 0;
  return /* @__PURE__ */ a(
    l,
    {
      role: "meter",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": e,
      ...m,
      children: [
        /* @__PURE__ */ r(i, { icon: p }),
        /* @__PURE__ */ a(d, { "data-testid": "meter-areas", "data-disabled": t, children: [
          /* @__PURE__ */ r(c, {}),
          /* @__PURE__ */ r(h, {}),
          /* @__PURE__ */ r(s, {}),
          n && /* @__PURE__ */ a(
            u,
            {
              style: {
                left: v(e)
              },
              children: [
                /* @__PURE__ */ r(f, { "data-testid": "dot" }),
                o
              ]
            }
          )
        ] }),
        /* @__PURE__ */ r(T, { icon: x })
      ]
    }
  );
}
export {
  D as Thermometer,
  v as getThermometerRange
};
